import Vue from 'vue';
import router from './router';
import { appStore } from './store';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import App from './App.vue';
import Vuelidate from 'vuelidate';
import moment from 'moment';
import Vue2TouchEvents from 'vue2-touch-events';

import vueDebounce from 'vue-debounce';
import { user$, setClientHeaders } from '@phrospr/lib-web-core';

import '@/plugins/vue2-timepicker/VueTimepicker.css';

// Announce this build to the API on every request (sw-builder.js injects window.app_version into
// the built index.html); the portal's release notes page shows which mobile app version runs.
const appVersion = (window as any).app_version;
if (appVersion) setClientHeaders({ 'X-Prospr-Mobile-Version': String(appVersion) });

Vue.use(VueMaterial);

Vue.use(Vuelidate as any);

Vue.use(Vue2TouchEvents);

Vue.use(vueDebounce, {
    defaultTime: '700ms',
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
    }
});

user$
    .then(_ => {
        new Vue({
            router,
            store: appStore,
            render: h => h(App as any),
        }).$mount('#app');
        // #E69138
        if (window.location.hash.startsWith('#/login')) return router.push('/');
    })
    .catch(err => {
        console.error('error checking login');
        console.error(err);
    });

// register service worker
if (process.env.VUE_APP_development !== 'true' && 'serviceWorker' in navigator) {
    console.log('trying to load serviceWorker');
    navigator.serviceWorker.register('/sw.js').then(
        registration => {
            // Registration was successful
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        },
        err => {
            // registration failed :(
            console.log('ServiceWorker registration failed: ', err);
        },
    );
} else {
    console.log('could not load service worker');
}
